/**
 * Created by Viacheslav Stepanian on 22.10.2026
 */

MiniPromo.prototype.replay = function (variant) {
    MiniPromo.VARIANT = variant;

    const view = this.findView();

    if (view) {
        cleverapps.focusManager.removeControl(MiniPromo.CONTROL);
        view.removeFromParent();
    }

    this.closed = false;
    this.show();
};

MiniPromo.prototype.demo = function (pause) {
    pause = pause || MiniPromo.DEMO_PAUSE;

    let index = 0;

    const play = () => {
        const variant = MiniPromo.VARIANTS[index++];

        if (!variant) {
            return;
        }

        console.log(`mini promo: ${variant}`);

        this.replay(variant);

        setTimeout(() => {
            const view = this.findView();
            const controller = view && ComponentUtils.findComponentByName(view, "MiniPromoController");

            if (controller) {
                controller.onClosePressed();
            }

            setTimeout(play, MiniPromo.DEMO_STEP + pause);
        }, MiniPromo.DEMO_STEP);
    };

    play();
};

MiniPromo.DEMO_STEP = 1800;
MiniPromo.DEMO_PAUSE = 1400;

cleverapps.Tool.miniPromo = ToolFolder.create(() => {
    const res = {
        demo: function () {
            cleverapps.miniPromo.demo();
        }
    };

    MiniPromo.VARIANTS.forEach((variant) => {
        res[variant] = function () {
            cleverapps.miniPromo.replay(variant);
        };
    });

    return res;
});
